// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".finish[data-v-16373637]{text-align:center;margin-top:180px}.finish h1[data-v-16373637]{color:#000;font-size:44px;line-height:42px;margin-bottom:80px}.finish a[data-v-16373637],.finish h1[data-v-16373637]{font-family:SFProDisplay-Medium,sans-serif}.finish a[data-v-16373637]{text-decoration:none;font-size:21px;line-height:26px}", ""]);
// Exports
module.exports = exports;
